module.exports = __webpack_public_path__ + "static/media/rsmAZdark.0ebc7b69.svg";